import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "f1a8cb8b-8eff-460b-ac48-2e2edf91af51",
    content: "Increased to R’<sub>w</sub> = 62 + 25 = 87 dB.",
    options: {},
  },
  { id: "1d1f262f-77bf-4bc0-8b4e-dbe651e2b4ed", content: "Reduced to R’<sub>w</sub> = 62 - 25 = 37 dB.", options: {} },
  { id: "be2a080e-a521-4221-b4d8-a8b040acf3f4", content: "Reduced to R’<sub>w</sub> = 31,3 dB.", options: {} },
  { id: "7ebd8d37-4fbc-4f28-985a-82620d2f9a65", content: "Same as for the concrete wall.", options: {} },
];

export const task: Task = {
  id: "8b176e31-3cf9-4f90-b183-6d9036b94d1d",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["be2a080e-a521-4221-b4d8-a8b040acf3f4"],
};
